export interface BlogPost {
  title: string;
  image: string;
  link: string;
  date: string;
  categories: string[];
}

export const BlogPosts: BlogPost[] = [
  {
    title: 'The Importance of Detailed Product Attributes in eCommerce',
    image: 'https://datacluster.com/wp-content/uploads/elementor/thumbs/The-Importance-of-Detailed-Product-Attributes-in-eCommerce-scaled-pv520fmq95m8t7ev0dxo4r6w7xhbe8w2j4ftg1msc0.jpg',
    link: 'https://datacluster.com/the-importance-of-detailed-product-attributes-in-ecommerce',
    date: 'May 5, 2022',
    categories: ['eCommerce'],
  },
  {
    title: '11 Common eCommerce Product Catalog Management Mistakes You Should Avoid At All Costs',
    image: 'https://datacluster.com/wp-content/uploads/elementor/thumbs/Catalog-Blog-Post-Cluster-pwhagbpnepomsfeigzurbli56qbqzjrk499r7wmn00.jpg',
    link: 'https://datacluster.com/common-ecommerce-product-catalog-management-mistakes',
    date: 'October 20, 2022',
    categories: ['eCommerce']
  },
  {
    title: 'Why Marketplaces Need eCommerce Catalog Management',
    image: 'https://datacluster.com/wp-content/uploads/elementor/thumbs/Untitled-design-2-pzje5xzelwho3aykylikiuy6cpn53ijgc3g7dldm28.jpg',
    link: 'https://datacluster.com/marketplace-ecommerce-catalog-management',
    date: 'December 22, 2022',
    categories: ['eCommerce']
  },
  {
    title: 'CEO Chat on Changing the Product Data Catalog Ownership Story',
    image: 'https://datacluster.com/wp-content/uploads/elementor/thumbs/CEO-Chat-on-Changing-the-Product-Data-Catalog-Ownership-Story-Ori-Greenberg-pxpiqaqvef56sw1eeqfjulhsx9m7g40x5oku4crn5c.png',
    link: 'https://datacluster.com/ori-greenberg-changing-the-product-data-catalog-ownership-story',
    date: 'November 14, 2022',
    categories: ['Catalog Enhancement', 'eCommerce', 'Marketplaces']
  },
  {
    title: 'The Importance of Detailed Product Attributes in eCommerce',
    image: 'https://datacluster.com/wp-content/uploads/elementor/thumbs/The-Importance-of-Detailed-Product-Attributes-in-eCommerce-scaled-pv520fmq95m8t7ev0dxo4r6w7xhbe8w2j4ftg1msc0.jpg',
    link: 'https://datacluster.com/the-importance-of-detailed-product-attributes-in-ecommerce',
    date: 'May 5, 2022',
    categories: ['eCommerce', 'Marketplaces'],
  },
  {
    title: '11 Common eCommerce Product Catalog Management Mistakes You Should Avoid At All Costs',
    image: 'https://datacluster.com/wp-content/uploads/elementor/thumbs/Catalog-Blog-Post-Cluster-pwhagbpnepomsfeigzurbli56qbqzjrk499r7wmn00.jpg',
    link: 'https://datacluster.com/common-ecommerce-product-catalog-management-mistakes',
    date: 'October 20, 2022',
    categories: ['eCommerce', 'Catalog Enhancement']
  },
  // {
  //   title: '',
  //   image: '',
  //   link: '',
  //   date: '',
  //   categories: []
  // },
  // {
  //   title: '',
  //   image: '',
  //   link: '',
  //   date: '',
  //   categories: []
  // },
];
